module.exports = __webpack_public_path__ + "pg.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/pg.svg
// module id = 1008
// module chunks = 0